import { leadingZero } from "../threads/cpcoc/leadingZero";
import { buildDownloadCSV } from "./buildDownloadCSV";
import { getSelectedMembers } from "./getSelectedMembers";
export function renderDownloadUI(html, members) {
    const container = document.createElement("div");
    const nowDate = new Date();
    const toStr = `${nowDate.getFullYear()}-${leadingZero(nowDate.getMonth())}-${leadingZero(nowDate.getDate())}`;
    nowDate.setMonth(nowDate.getMonth() - 1);
    const fromStr = `${nowDate.getFullYear()}-${leadingZero(nowDate.getMonth())}-${leadingZero(nowDate.getDate())}`;
    container.classList.add("attendance-data__container");
    let htmlStr = `
        <p class="attendance-data__from">
            <label for="from" class="attendance-data__label">From:</label>
            <input class="listen-change" type="date" id="from" name="trip-start" value="${fromStr}" max="${toStr}" />
        </p>
        <p class="attendance-data__to">
            <label for="to" class="attendance-data__label">To:</label>
            <input class="listen-change" type="date" id="to" name="trip-start" value="${toStr}" max="${toStr}" />
        </p>
        <p class="attendance-data__select-members">
            <label for="members" class="attendance-data__label">Select Members:</label>
            <select class="listen-change" id="members" multiple>`;
    for (let i = 0, l = members.length; i < l; i++) {
        const member = members[i];
        htmlStr += `<option value="${member["member-id"]}" data-id="${member["member-id"]}" data-groups="${member.groups || ""}" data-name="${member["first-name"]} ${member["last-name"]}">${member["last-name"]}, ${member["first-name"]}</option>`;
    }
    htmlStr += `
            </select>
        </p>
    `;
    container.innerHTML = htmlStr;
    container.innerHTML += `
        <div class="attendance-data__footer">
            <p class="attendance-data__summary">${generateSummary(container)}</p>
            <p class="attendance-data__btn-container">
                <button id="download">
                    Download CSV
                    <i class="fa-solid fa-download"></i>
                </button>
            </p>
        </div>
    `;
    html.replaceChildren(container);
    container.addEventListener("click", (e) => {
        if (e.target.id === "download") {
            buildDownloadCSV();
        }
    });
    container.querySelectorAll(".listen-change").forEach((elem) => {
        elem.addEventListener("change", () => {
            container.querySelector(".attendance-data__summary").innerHTML =
                generateSummary(container);
        });
    });
}
function generateSummary(root) {
    const optionElems = root.querySelectorAll("#members option");
    const selectedMembers = getSelectedMembers(optionElems);
    const from = root.querySelector("#from").value;
    const to = root.querySelector("#to").value;
    if (optionElems.length === selectedMembers.length) {
        return `Click to download data for <strong>all members</strong> between <strong>${from}</strong> and <strong>${to}</strong> dates.`;
    }
    return `Click to download data for <strong>${selectedMembers.length} member${selectedMembers.length > 1 ? "s" : ""}</strong> between <strong>${from}</strong> and <strong>${to}</strong> dates.`;
}
